module.exports = __webpack_public_path__ + "static/img/bg-es.900efd64.png";